<template>
	<div id="gallery-area">

		<div class="row justify-content-center" v-if="gallery.elements.length">
			<div class="col-xl-10 col-xxl-8">
				<form @submit.prevent="submitSearch">
					<div class="row justify-content-center">
						<div class="col-md-6 form-group mt-4 mb-1 position-relative">
							<i class="fa fa-search position-absolute c-pointer" @click.prevent="submitSearch"></i>
							<input type="text" placeholder="Cerca il nome della tua scuola" class="form-control form-control-lg pe-4" v-model="gallery.search">
						</div>

						<div class="col-md-6 form-group mt-4 mb-1 position-relative">
							<select id="referente" name="referente" class="form-select form-select-lg custom-select d-block" v-model="gallery.ordine">
								<option value="" class="placeholder">Seleziona ordine scuola</option>
								<option value="primaria">Scuola primaria</option>
								<option value="secondaria">Scuola secondaria I grado</option>
							</select>
						</div>

					</div>
				</form>
			</div>
		</div>

		<transition name="fade">
			<div id="gallery-container" class="row pt-4 justify-content-center" v-if="gallery.elements.length">
				<div class="col-11 col-sm-10 col-md-6 col-lg-6 col-xl-4 mb-4" v-for="(work, index) in gallery.elements" :key="index" @click.prevent="showWork(work.url_media, `<div class='text-white bold fs-1'><span>` + work.classe + work.sezione + `</span> - <span>` + work.nome + `</span></div><div class='text-white fs-1'><span>` + work.citta + `</span></div>`, `<p class='mb-0'>` + work.text + `</p>`)" style="">

					<div class="row">
						<div class="col-12 square position-relative text-white">
							<div class="square-text-inner text-start img-modal" :style="'background-image: url(' + themaUrl + '/img/' + work.sfondo_img + ')'" style="background-repeat:no-repeat;background-position:center;background-size:cover;">
								<div class="inner-txt semibold w-100 px-3 py-4" :class="{ 'fs-3-5 lh-3-5': work.text.length <= 25, 'fs-3 lh-3': work.text.length <= 50 && work.text.length > 25, 'fs-2 lh-2': work.text.length <= 100  && work.text.length > 50, 'fs-1-8 lh-2': work.text.length <= 200  && work.text.length > 100}">
									<span class="va-top">{{work.text}}</span>
								</div>
							</div>
						</div>

						<div class="col-12">
							<div class="inner-caption bold fs-1-3 font-family-caveat w-100 px-3 py-3 did-section">
								<div class="fs-1-1">
									<span>{{work.classe}}{{work.sezione}}</span> - <span>{{work.nome}}</span>
								</div>
								<div class="fs-1-1">
									<span>{{work.citta}}</span>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
		</transition>

		<div id="gallery-container" class="row pt-5 justify-content-center align-items-center mb-5 empty-gallery mt-5" v-if="!gallery.elements.length && gallery.showMsg === true">
			<div class="col-sm-10 text-center" v-if="gallery.search == ''">
				<p class="fs-2 lh-1-3" v-if="workType == 'primary'">Il progetto è iniziato da poco: gli studenti stanno ideando nuove occasioni di benessere!</p>
			</div>
			<div class="col-sm-10 text-center" v-else>
				<p class="fs-2">Non ci sono contributi che corrispondono alla ricerca effettuata.</p>
				<button class="btn btn btn-green btn-lg px-4 mt-2 bold" @click.prevent="onResetSearch">
					<span class="va-sub">RESET</span>
				</button>
			</div>
		</div>

		<div class="row justify-content-center">
			<div class="col-12">
				<pagination
					v-model="gallery.pageNo"
					:records="parseInt(gallery.totElements)"
					:per-page="perPage"
					:options=optionsPag
					@paginate="getGalleryElements"
				></pagination>
			</div>
		</div>

		<modal name="gallery-modal"
			height="auto"
			:adaptive="false"
			:width="maxModalWidth"
			:scrollable="true"
			classes="modal-override"
			id="gallery-modal"
		>
			<div class="modal-header text-end bg-transparent p-0 justify-content-end border-0 lh-1">
				<button type="button" class="px-0 pt-0 pb-2 bold border-0 bg-transparent text-white" data-dismiss="modal" aria-label="Close" @click.prevent="$modal.hide('gallery-modal')" style="margin-right:-15px;">
					<i class="bi bi-x fs-3-5"></i>
				</button>
			</div>
			<div class="img-modal px-4 pt-4 pb-2 m-0 bg-white">
				<img :src="modal.img" alt="gallery" class="img-fluid w-100 pt-2">
			</div>
			<div class="text-start bg-white">
				<div class="pb-2 px-4 fs-1 text-start" v-html="modal.htmlDid"></div>
			</div>
			<div class="text-center" :style="'background-color:' + didColor + ';'">
				<div class="py-2 px-3 text-white fs-1-1 text-center" v-html="modal.html"></div>
			</div>
		</modal>

	</div>
</template>

<script>
import axios from 'axios'
import Pagination from 'vue-pagination-2'
import CustomPagination from './CustomPagination.vue'

export default {
	name: 'GalleryComponent',
	props: ['perPage', 'themaUrl', 'workType', 'didColor'],
	components: {Pagination},

	data() {
		return {
			urlHost: this.themaUrl,
			ajaxObj: window.ajax_object,
			themeUrl: this.themaUrl,
			worksDir: this.urlHost + 'wp-content/uploads/works/',
			bgUrl: '',
			gallery: {
				xpage: this.perPage,
				pageNo: 1,
				totElements: 0,
				search: '',
				ordine: '',
				valori: '',
				elements: [],
				showMsg: false,
				isEnd: false
			},
			modal: {
				img: '',
				color: '',
				html: '',
				htmlDid: ''
			},
			isLoading: false,
			maxModalWidth: window.outerWidth <= 700 ? (window.outerWidth - 100) : 700,
			optionsPag: {
				chunk: 6,
				texts: {
					count: "pagina {page} di {pages}",
				},
				template: CustomPagination
			}
		}
	},

	methods: {
		getGalleryElements() {
			this.isLoading = true
			let url = this.ajaxObj.ajax_url

			let formData = new FormData();
			formData.append('action', 'nl_get_works')
			formData.append('_nounce_value', this.ajaxObj._nounce_value)
			formData.append('xpage', this.gallery.xpage)
			formData.append('current_page', this.gallery.pageNo)
			formData.append('work_type', this.workType)
			formData.append('search', this.gallery.search)
			formData.append('valori', this.gallery.valori)

			axios.post(url, formData)
				.then((response) => {
					let _this = this
					_this.gallery.totElements = response.data.tot_works
					// console.log(response.data)
					this.gallery.showMsg = false
					if (response.data.gallery_elements.length) {

						// let galleryElTmp = _this.gallery.elements
						_this.gallery.showMsg = false
						_this.gallery.elements = []
						setTimeout(function() {
							_this.gallery.elements = response.data.gallery_elements
						}, 250, _this);
					} else {
						_this.gallery.elements = []
						_this.gallery.showMsg = true
					}

					this.isLoading = false
					this.gallery.isEnd = response.data.disable_btn == 1 ? true : false
				}, (error) => {
					this.isLoading = false
					console.log(error);
				});
		},

		gallerySearch() {
			this.gallery.pageNo = 1
			this.gallery.elements = []
			this.getGalleryElements()
		},

		onResetSearch() {
			this.gallery.search = ''
			this.gallerySearch()
		},

		loadMore() {
			this.gallery.pageNo = this.gallery.pageNo + 1
			this.getGalleryElements()
		},

		paginationCallBack(page) {
			this.pageNo = page
			this.getGalleryElements()
		},

		showWork(img, html, htmlDid) {
			this.modal.color = ''
			this.modal.img = ''
			this.modal.html = ''
			if(img) {
				this.modal.img = img
				this.modal.html = html
				this.modal.htmlDid = htmlDid
				this.$modal.show('gallery-modal')
			}

		},

		submitSearch() {
			this.gallery.pageNo = 1
			this.getGalleryElements()
		}
	},

	mounted() {
		this.getGalleryElements()
	}

}
</script>

<style scoped>
.vid-container {
	width: 100%;
	padding-top: 100%;
	position: relative;
	background-color: transparent;
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
}
.vid-inner {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	padding: 1% 5%;
}
.camera {
	position: absolute;
	max-width: 64px;
	bottom: 15px;
	right: 15px;
	cursor: pointer;
}
.form-control {background-color: #ffffff;}
.square {
	overflow: hidden;
}
.square::after {
	content: "";
	display: block;
	padding-bottom: 105%;

}
@media (max-width: 575.98px) {
	.square::after {
		padding-bottom: 128%;
	}
}
@media (max-width: 575.98px) {
	.square::after {
		padding-bottom: 160%;
	}
}
@media (max-width: 991.98px) {
	.square::after {
		padding-bottom: 162%;
	}
}
@media (min-width: 1200px) {
	.square::after {
		padding-bottom: 110%;
	}
}
@media (min-width: 1400px) {
	.square::after {
		padding-bottom: 100%;
	}
}
.square-inner {
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	/*border: 2px solid #000;*/
}
.square-inner > img {
	object-fit: cover;
	object-position: center;
	width: 100%;
	height: 100%;
}
.square-text-inner {
	position: relative;
	width: 100%;
	height: 100%;
}
.square-text-inner .inner-caption {
	position: absolute;
	left: 0;
	bottom: 0;
	/*border-top: 4px solid #000000;*/
}

.square-text-inner .inner-txt {
	position: absolute;
	left: 0;
	top:0;
}
.bi-arrow-repeat.rotating {
	display: none;
	vertical-align: text-bottom;
}
.form-select-lg {
	padding-top: 0.8rem;
    padding-bottom: 0.82rem;
	font-size: .82rem;
}
i.fa-search {
    font-size: 1.3rem;
    color: #333;
    top: 50%;
    right: 1.25rem;
	transform: translateY(-50%);
}
</style>
